module.exports = __webpack_public_path__ + "img/585cbd3.png";